import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  output,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslationCoreModule } from '@qtek/libs/translation-core';

/** Welcome shown on the first page after an account was created through Microsoft sign-in. */
@Component({
  selector: 'qt-sso-welcome-banner',
  templateUrl: './sso-welcome-banner.component.html',
  styleUrls: ['./sso-welcome-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatButtonModule, MatIconModule, TranslationCoreModule],
})
export class SsoWelcomeBannerComponent {
  readonly company = input.required<string>();
  readonly roleLabel = input.required<string>();
  readonly closed = output<void>();

  readonly titleFallback = 'Welcome to Synply';
  // The translate pipe does not substitute params into a fallback, so it is composed here.
  readonly messageFallback = computed(
    () =>
      `You have been added to ${this.company()} at ${this.roleLabel()}. An administrator can give you access to deals.`
  );
}
